<template>
    <div class="patient-case-edit">
        <div
            class="patient-case-item"
            v-for="sec of sections"
            :key="sec"
            :class="{ open: open[sec] }"
        >
            <strong
                class="patient-case-title p-3 d-block pointer m-0"
                @click="secClicked(sec)"
            >
                <angle-icon></angle-icon>
                {{ $t(sec) }}
            </strong>
            <div class="patient-case-content">
                <div class="pb-3">
                    <components
                        :is="sec"
                        :value="value"
                        v-if="value && caseById(value)"
                    ></components>
                </div>
            </div>
        </div>
        <button
            class="btn btn-outline-primary btn-block"
            @click.prevent="finishCase"
        >
            {{ $t("finishCase") }}
        </button>
        <a
            :href="`/cases/${value}/report`"
            target="_blank"
            class="btn btn-outline-primary btn-block"
        >
            {{ $t("printCase") }}
        </a>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import AngleIcon from "@/components/Icons/Angle";
import Schedules from "@/components/Cases/Sections/Schedules";
import Evidences from "@/components/Cases/Sections/Evidences";
import Diagnosis from "@/components/Cases/Sections/Diagnosis";
import FileUpload from "@/components/Cases/Sections/FileUpload";
import Conclusion from "@/components/Cases/Sections/Conclusion";
import References from "@/components/Cases/Sections/References";
import Comment from "@/components/Cases/Sections/Comment";
import Labtests from "@/components/Cases/Sections/Labtests";
import Treatment from "@/components/Cases/Sections/Treatment";
import ServiceRequests from "@/components/Cases/Sections/ServiceRequests";
import Infermedica from "@/components/Cases/Sections/Infermedica";
export default {
    components: {
        Evidences,
        Diagnosis,
        Schedules,
        FileUpload,
        Conclusion,
        References,
        Comment,
        Labtests,
        Treatment,
        AngleIcon,
        ServiceRequests,
        Infermedica,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            open: {
                Schedules: false,
                FileUpload: false,
                Comment: false,
                Diagnosis: false,
                Evidences: false,
                Conclusion: false,
                Labtests: false,
                Treatment: false,
            },
        };
    },
    computed: {
        ...mapGetters({
            caseById: "pcase/byId",
            servicetplById: "servicetpl/byId",
            authType: "auth/type",
        }),
        sections() {
            if (this.authType === "Doctor") {
                return ["Schedules"].concat(
                    this.servicetplById(this.caseById(this.value).template)
                        .permitted_actions,
                );
            }
            return this.servicetplById(this.caseById(this.value).template)
                .permitted_actions;
        },
    },
    mounted() {
        console.log(this.caseById(this.value));
    },
    methods: {
        ...mapMutations({
            setError: "alert/setError",
            setCase: "pcase/set",
            setPanelComponent: "panel/setComponent",
        }),
        secClicked(sec) {
            this.$set(this.open, sec, !this.open[sec]);
        },
        async finishCase() {
            try {
                const params = { comment: this.comment };
                const response = await this.axios.post(
                    `/api/patient-cases/${this.value}/complete`,
                    params,
                );
                const c = response.data.data;
                this.setCase(c);
                this.setPanelComponent({ id: c.id, component: "patient-case" });
            } catch (err) {
                this.setError(err);
            }
        },
    },
};
</script>
<style lang="scss">
.patient-case-edit {
    font-size: 0.75em;
    .list {
        .item {
            small {
                transition: all 0.2s;
                svg {
                    width: 20px;
                    height: 20px;
                    transition: all 0.2s;
                }
                &:hover {
                    background-color: #eee;
                }
            }
            a,
            button,
            label {
                transition: all 0.2s;
                background-color: #fff;
                border: none;
                display: block;
                text-decoration: none;
                width: 100%;
                border-top: 1px solid #ccc;
                border-left: 1px solid #ccc;
                color: #555;
                &:hover {
                    background-color: #eee;
                }
                svg {
                    width: 18px;
                    height: 18px;
                    transition: all 0.2s;
                }
                small {
                    svg {
                        width: 16px;
                        height: 16px;
                        transition: all 0.2s;
                        margin-top: -5px;
                    }
                }
                .closed {
                    svg {
                        transform: rotate(-90deg);
                    }
                }
                .open {
                    svg {
                        transform: rotate(0deg);
                    }
                }
            }
        }
        // .item-action {
        // }
        .item-last {
            a,
            button,
            label {
                border-right: 1px solid #ccc;
            }
        }
        .item-bottom {
            a,
            button,
            label {
                border-bottom: 1px solid #ccc;
                background-color: #eee;
            }
        }
    }

    .patient-case-item {
        .patient-case-title {
            // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            // border-bottom: 1px solid #eee;
            &:hover {
                background-color: #f8f9fa;
            }
            svg {
                transition: all 0.2s;
                transform: rotate(-90deg);
                width: 16px;
                height: 16px;
            }
        }
        .patient-case-content {
            // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            border-bottom: 1px solid #eee;
            overflow: hidden;
            height: 0px;
        }
        &.open {
            .patient-case-title {
                svg {
                    transform: rotate(0deg);
                    width: 16px;
                    height: 16px;
                }
            }
            .patient-case-content {
                height: auto;
            }
        }
    }
}
</style>
<i18n>
{
  "ka": {
    "Schedules": "ქეისის ფარგლებში ჩატარებული ვიზიტები",
    "finishCase": "ქეისის დასრულება",
    "printCase": "ქეისის საბეჭდი ვერსია",
    "FileUpload": "კვლევების შედეგები (ფაილები)",
    "Comment": "კომენტარი",
    "Diagnosis": "დიაგნოზი",
    "Evidences": "სიმპტომები",
    "Infermedica": "ხელოვნური ინტელექტის დასკვნა",
    "Conclusion": "დასკვნა",
    "Labtests": "AI ლაბორატორიული მონაცემები",
    "Treatment": "დანიშნულება",
    "ServiceRequests": "მოთხოვნილი სერვისები",
    "References": "მიმაგრებული ჩანაწერები"
  },
  "en": {
    "Schedules": "Schedules within the case",
    "finishCase": "Finish Case",
    "printCase": "Case Print Version",
    "FileUpload": "Results",
    "Comment": "Comment",
    "Diagnosis": "Diagnosis",
    "Evidences": "Evidences",
    "Infermedica": "AI Conclusion",
    "Conclusion": "Conclusion",
    "Labtests": "AI Labtests",
    "Treatment": "Treatment",
    "ServiceRequests": "Service Requests",
    "References": "References"
  }
}
</i18n>
